module.exports = __webpack_public_path__ + "img/glass.1cbc5bb8.svg";